export function secondsToHms(d) {
	const h = Math.floor(d / 3600);
	const m = Math.floor((d % 3600) / 60);

	return {
		time: `${h}.${m.toString().length === 1 ? `0${m.toString()}` : m}`,
		label: h > 0 ? 'hours' : 'mins'
	};
}

export function calculateAspectRatioFit(srcWidth, srcHeight, maxWidth, maxHeight) {
	const ratio = Math.min(maxWidth / srcWidth, maxHeight / srcHeight);
	return { width: srcWidth * ratio, height: srcHeight * ratio };
}

export function capitalize(str) {
	return str.substring(0, 1).toUpperCase() + str.substring(1);
}

export function loadImage(src) {
	return new Promise((resolve, reject) => {
		try {
			const image = new Image();

			image.onload = () => {
				resolve(image);
			};

			image.onerror = err => {
				reject(err);
			};

			image.src = src;
		} catch (ex) {
			reject(ex);
		}
	});
}

export function canvasToImage(canvas) {
	return new Promise((resolve, reject) => {
		try {
			const image = canvas.toDataURL('image/png', 1.0);
			const imageElement = new Image();

			imageElement.onload = () => {
				resolve(imageElement);
			};

			imageElement.src = image;
		} catch (ex) {
			reject(ex);
		}
	});
}

export function generateCanvas() {
	const canvas = document.createElement('canvas');
	const ctx = canvas.getContext('2d');

	canvas.width = 700;
	canvas.height = 1400;

	return { canvas, ctx };
}
